/**
 * Creates a small cookie consent pop-up and appends it to the end of the
 * passed container element.
 *
 * Once accepted, sets a cookie to test next time. Doesn't execute if this
 * cookie is already set.
 *
 * @param {string} text The text to display in the element.
 * @param {string} ppURL Full URL to the Privacy Policy page.
 * @param {object} args (Optional) - as follows: (all strings)
 * 		parent 					DOM selector for the element to append to. (Default='body')
 * 		containerClass 			Class to add to the created element. (Default='cookie-consent')
 * 		containerControlClass	Class to add to the created element when the accept button is clicked. (Default='accepted')
 * 		acceptButtonClass		Class to add to the accept button. (Default='btn--cta')
 * 		acceptButtonText		The text value of the accept button. (Default='Accept')
 * 		ppButtonClass			Class to add to the privacy policy button. (Default='btn--cta alt')
 * 		ppButtonText			The text value of the privacy policy button. (Default='Privacy Policy')
 * 		cookieName				The name of the cookie to set and test for. (Defailt='cookiesaccepted')
 */


import cookies from './cookies';

const _defaults = {
	parent: 'body',
	containerClass: 'cookie-consent',
	containerControlClass: 'accepted',
	acceptButtonClass: 'btn--cta',
	acceptButtonText: 'Accept',
	ppButtonClass: 'btn--cta alt',
	ppButtonText: 'Privacy Policy',
	cookieName: 'cookiesaccepted'
};

function cookieNotice(text, ppURL, args) {
	const options = { ..._defaults, ...args };

	// First, check if the cookie has been set. No point otherwise!
	const cookieSet = cookies.get(options.cookieName);
	if (cookieSet === 'true') return; // No need to continue, cookies accepted.

	// Create and add the actual elements.
	const parent = document.querySelector(options.parent);
	if (!parent) throw new Error('cookie-notice creation - parent element not found.');

	// Create the main element and set class/text.
	const container = document.createElement('div');
	container.setAttribute('class', options.containerClass);
	const containerParagraph = document.createElement('p');
	const content = document.createTextNode(text);
	containerParagraph.appendChild(content);
	container.appendChild(containerParagraph);

	// Create the accept button
	const acceptButton = document.createElement('a');
	acceptButton.setAttribute('role', 'button');
	acceptButton.setAttribute('class', options.acceptButtonClass);
	acceptButton.innerHTML = options.acceptButtonText;
	container.appendChild(acceptButton);

	// Create the privacy policy button
	const ppButton = document.createElement('a');
	ppButton.setAttribute('href', ppURL);
	ppButton.setAttribute('class', options.ppButtonClass);
	ppButton.setAttribute('target', 'blank');
	ppButton.setAttribute('value', options.ppButtonText);
	ppButton.innerHTML = options.ppButtonText;
	container.appendChild(ppButton);

	parent.appendChild(container);

	// Accept, add cookie, add control class.
	const acceptHandler = e => {
		e.preventDefault();
		cookies.set(options.cookieName, 'true', 30);
		container.classList.add(options.containerControlClass);
	};

	acceptButton.onclick = acceptHandler;
};

export default cookieNotice;